<template>
<component :is="layout">
  <router-view />
</component>
<loading-content-component />
<!-- <mobile-map-overlay  /> -->
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import LoadingContentComponent from "./components/misc/LoadingContent.vue";
  import MobileMapOverlay from "./components/misc/MobileMapOverlay.vue";
  const default_layout = "default";

  export default defineComponent({
    name: "App",
    components: {
      LoadingContentComponent,
      MobileMapOverlay,
    },
    computed: {
      layout() {
        return (this.$route.meta.layout || default_layout) + "-layout";
      },
    },
    methods: {
      //myUndefinedFunction();
    },

  });
</script>